import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['button'];

  connect() {}

  disconnect() {}

  onPlay() {
    if (this.hasButtonTarget) {
      Array.from(this.buttonTargets, button => {
        button.removeAttribute('disabled');
        button.classList.remove('disabled');
      });
    }
  }

  satisfy() {
    this.data.set('satisfied', 'true');
  }
}
